import { useState } from "react";
import "./trial.scss";

// Homepage body section (owner request 2026-11-03): free trial ONLY.
// The $20 paid trial was removed from the site. Free class form
// collects name/age/location/email and we email to schedule.
// Owner offer: finish the free trial + sign up for regular classes
// = free uniform.
const FREE_FORM_EMBED =
  "https://docs.google.com/forms/d/e/1FAIpQLSfck0LnNu6_-wZNFydn46LvaeE0kVx4Y1Nfz9eYa74hn0WIYg/viewform?embedded=true";

export default function Trial() {
  const [showFreeForm, setShowFreeForm] = useState(false);

  return (
    <section className="section trial-section" id="trial">
      <div className="container trial-container">
        <p className="trial-eyebrow">25TH ANNIVERSARY</p>
        <h2 className="trial-title">Try Taekwondo — First Class FREE</h2>
        <p className="trial-lead">
          One free class, no payment, no commitment — signing up takes
          1 minute. Finish your trial and sign up for regular classes
          to get a FREE uniform.
        </p>

        <div className="grid trial-steps">
          <div className="trial-step">
            <h3>1. Book online</h3>
            <p>Book your free class below.</p>
          </div>
          <div className="trial-step">
            <h3>2. We contact you</h3>
            <p>We email you to schedule your first class.</p>
          </div>
          <div className="trial-step">
            <h3>3. Come train</h3>
            <p>Train at Clinton or Basking Ridge — your choice.</p>
          </div>
        </div>

        <div className="grid trial-locations">
          <div className="trial-location">
            <h3>Basking Ridge</h3>
            <p>403 King George Rd, Basking Ridge, NJ 07920</p>
          </div>
          <div className="trial-location">
            <h3>Clinton</h3>
            <p>114 W Main St, Clinton, NJ 08809</p>
          </div>
        </div>

        <div className="free-trial">
          <h3 className="free-trial-title">Start FREE — 1 Trial Class</h3>
          <p className="free-trial-lead">
            No payment, no commitment. Tell us your name, age and location,
            and we'll email you to schedule your free class.
          </p>
          {showFreeForm ? (
            <iframe
              className="free-trial-form"
              title="Book a Free Trial Class"
              src={FREE_FORM_EMBED}
              loading="lazy"
            >
              Loading…
            </iframe>
          ) : (
            <button
              type="button"
              className="free-trial-button"
              onClick={() => setShowFreeForm(true)}
            >
              Book My FREE Class
            </button>
          )}
          <p className="trial-alt">
            Prefer email over the form?{" "}
            <a href="mailto:pskyman1@gmail.com?subject=Free%20Trial%20Class%20Request">
              Email us your name, age, and branch (Clinton / Basking Ridge)
            </a>{" "}
            and we'll schedule your free class.
          </p>
        </div>

        <div className="trial-uniform">
          <h3 className="trial-uniform-title">
            🥋 Finish Your Trial → FREE Uniform
          </h3>
          <p className="trial-uniform-text">
            Love your first class? Sign up for regular classes and get
            a FREE uniform. Questions?{" "}
            <a href="mailto:pskyman1@gmail.com">
              Email us at pskyman1@gmail.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
